import styles from './ListViewRow.module.scss'
import React from 'react'

type Props = {
  children: React.ReactNode
}

const ListViewRow = (props: Props) => {
  return (
    <div className={styles.component}>
      {props.children}
    </div>
  )
}

export default ListViewRow